import React from "react"

const MessageIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M4 10.668C4 8.45883 5.79086 6.66797 8 6.66797H24C26.2091 6.66797 28 8.45883 28 10.668V21.3346C28 23.5438 26.2091 25.3346 24 25.3346H8C5.79086 25.3346 4 23.5438 4 21.3346V10.668Z"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        d="M9.33203 12L15.9987 17.3333L22.6654 12"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default MessageIcon
